// extracted by mini-css-extract-plugin
export default {"container":"Header_container__JbN-N","wrapper":"Header_wrapper__uinIK","title":"Header_title__UB+dw","alert":"Header_alert__JeYZX","iconCheck":"Header_iconCheck__n6-sn"};